module.exports = __webpack_public_path__ + "static/media/Sudhamurthy- P.2.4ef9306f.JPG";